import axios from 'axios';

export default {
  storeSendbox(sendbox) {
    return axios.post('/sendbox/', sendbox);
  },
};
